import React from 'react';
import { Box, Link, styled, Breadcrumbs } from '@dripcapital/dripui-v1';
import { LinkType } from 'types';
import NavigateNext from '@mui/icons-material/NavigateNext';
import { FONT } from 'utils';

type Props = {
  breadcrumbs?: LinkType[];
  padding?: string | number;
};

const Container = styled(Box)<{ customPadding?: string | number }>(
  ({ theme, customPadding }) => {
    return {
      padding:
        customPadding !== undefined ? customPadding : `0 ${theme.spacing(8)}`,
      '@media (max-width: 1024px)': {
        padding:
          customPadding !== undefined ? customPadding : `${theme.spacing(2)}`,
      },
    };
  }
);

const BreadCrumbs: React.FC<Props> = ({ breadcrumbs, padding }: Props) => {
  return (
    <Container dataTestId="breadcrumb-element" customPadding={padding}>
      <Breadcrumbs
        separator={<NavigateNext sx={{ fontSize: FONT.SIZES.F20 }} />}
        aria-label="breadcrumb"
      >
        {breadcrumbs &&
          Array.isArray(breadcrumbs) &&
          breadcrumbs.map((link: LinkType, index: number) => {
            const { dataTestId, label, href, color, underline, handleClick } =
              link;
            return (
              <Link
                dataTestId={dataTestId}
                key={index}
                underline={underline}
                color={color}
                href={href}
                onClick={handleClick}
                _sx={{
                  fontSize: FONT.SIZES.F16,
                  fontWeight:
                    breadcrumbs.length - 1 === index
                      ? FONT.WEIGHT.BOLD
                      : 'initial',
                }}
              >
                {label}
              </Link>
            );
          })}
      </Breadcrumbs>
    </Container>
  );
};

export default BreadCrumbs;
